var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apps_home_wrap"},[_c('Title',{attrs:{"title":'获取应用',"desc":'请根据需求，选择适合您的应用'}}),_c('WeappCheck'),_c('PdaCheck'),_c('PcCheck'),_c('AiCheck')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }